import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: [] };

export const GridTableCheckboxSlice = createSlice({
  name: 'GridTableData',
  initialState,
  reducers: {
    storeGridTableData: (state, action) => {
      const payload = action.payload;
      state.data = payload;
    },
    addGridTableData: (state, action) => {
      if (action.payload.checked) {
        state.data.push(action.payload);
      } else {
        state.data = state.data.filter((item) => item.id !== action.payload.id);
      }
    },
    flushGridTableData: () => initialState,
    addBulkData: (state, action) => {
      console.log('slice', action.payload);
      state.data.push(...action.payload);
    },
    deleteGridTableData: (state, action) => {
      const id = action.payload;
      state.data = state.data.filter((item) => item.id !== id);
    },
  },
});

export const { storeGridTableData, addGridTableData, flushGridTableData, deleteGridTableData, addBulkData } = GridTableCheckboxSlice.actions;
export default GridTableCheckboxSlice.reducer;
